import { apiRequest } from './httpClient';

// Endpoints of backend/routers/bot_meetings.py.

// `<input type="datetime-local">` values carry no timezone, and the API
// rejects a timestamp without one. Date parses a zone-less value as LOCAL
// time; toISOString() then pins it to an unambiguous UTC instant.
export function toIsoTimestamp(value) {
  const date = value instanceof Date ? value : new Date(value);

  if (Number.isNaN(date.getTime())) {
    throw new Error('Choose a valid date and time.');
  }

  return date.toISOString();
}

// when: 'upcoming' (soonest first) | 'past' (newest first).
export function listBotMeetings(when = 'upcoming') {
  return apiRequest(`/api/bot-meetings?when=${encodeURIComponent(when)}`);
}

export function getBotMeeting(meetingId) {
  return apiRequest(`/api/bot-meetings/${encodeURIComponent(meetingId)}`);
}

export function scheduleBotMeeting({
  title,
  meetingUrl,
  scheduledStartAt,
  spokenLanguage,
  summaryLanguage,
  meetingType,
  programmingLanguages,
}) {
  return apiRequest('/api/bot-meetings', {
    method: 'POST',
    body: {
      title,
      meeting_url: meetingUrl,
      scheduled_start_at: toIsoTimestamp(scheduledStartAt),
      spoken_language: spokenLanguage || 'auto',
      // null/omitted means English server-side.
      ...(summaryLanguage ? { summary_language: summaryLanguage } : {}),
      // AI answer context - omitted at the defaults ("general" / none),
      // which the backend applies itself.
      ...(meetingType && meetingType !== 'general' ? { meeting_type: meetingType } : {}),
      ...(programmingLanguages && programmingLanguages.length > 0
        ? { programming_languages: programmingLanguages }
        : {}),
    },
  });
}

export function cancelBotMeeting(meetingId) {
  return apiRequest(`/api/bot-meetings/${encodeURIComponent(meetingId)}/cancel`, {
    method: 'POST',
  });
}

// End Meeting for an Auto Attend bot that is recording: asks THAT bot to
// leave the external meeting. It does not end the meeting itself - the
// bot leaving does, a few seconds later - so the answer still shows the
// bot as recording. Safe to send twice.
export function stopBotMeeting(meetingId) {
  return apiRequest(`/api/bot-meetings/${encodeURIComponent(meetingId)}/stop`, {
    method: 'POST',
  });
}

export function rescheduleBotMeeting(meetingId, scheduledStartAt) {
  return apiRequest(`/api/bot-meetings/${encodeURIComponent(meetingId)}/reschedule`, {
    method: 'POST',
    body: { scheduled_start_at: toIsoTimestamp(scheduledStartAt) },
  });
}
